import { Observable } from 'rxjs';
import { SearchServiceModel } from 'src/app/store/self-diagnostic/search-service/model';
import { SelfDiagnosticStepModel } from 'src/app/store/self-diagnostic/self-diagnostic-step/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractSelfDiagnosticApiService {
  public abstract searchService(searchString: string): Observable<InteractorResponse<SearchServiceModel[]>>;
  public abstract getSelfDiagnosticStep(serviceId: number, step: number): Observable<InteractorResponse<SelfDiagnosticStepModel>>;
  //public abstract rate(serviceId: number, step: number, rate: number): Observable<InteractorResponse<any>>;
}
